import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('summarize');
const type = createActionType('summarize');

export const ADD_DIMENSIONS = type('AddDimensions');
export const DELETE_DIMENSION = type('DeleteDimension');
export const MOVE_DIMENSION = type('MoveDimension');
export const TOGGLE_COUNT_MEASURE = type('ToggleCountMeasure');
export const UPDATE_COLUMN = type('UpdateColumn');
export const UPDATE_VALUES = type('UpdateValues');
export const UPDATE_AGGREGATION = type('UpdateAggregation');

export const CREATE_SUMMARIZE_OPERATION = type('CreateSummarizeOperation');
export const UPDATE_SUMMARIZE_OPERATION = type('UpdateSummarizeOperation');

export const INITIALIZE = type('Initialize');
export const INITIALIZE_DIMENSIONS = type('InitializeDimensions');
export const INITIALIZE_SOURCE_COLUMNS = type('InitializeSourceColumns');

export const LOAD_COLUMN_VALUES = apiType('LoadColumnValues');

export const RELOAD_PREVIEW = type('ReloadPreview');
